import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  message: {
    margin: [theme.spacing(1), 0],
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
  },
  bold: {
    color: theme.palette.colors.emerald,
    opacity: 0.5,
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/LoanOfficerCard/components/LastMessage/useStyles.js